// extracted by mini-css-extract-plugin
export default {"f":"f61c4dbdcd","main":"_923fa43d4e","btn":"_4038d772c7","w":"e0f6d2d92d","h":"f8fca6a004","lh25":"_5fa5f7e238","wb":"_46bd712574","b":"c5fba59f66","bx":"_57bc8c94fa"};